import React from "react";
// utils
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const ProgressStatus = ({
  customStyles,
  dataDetail,
  distributionStatus,
  statusOnClick,
  targetStatus,
  statusChangeOnSubmit,
  currentStatus,
  modalStepIsOpen,
  toggleModalSteps,
}) => {
  return (
    <div className="relative w-full h-full w-12/12 flex justify-center items-start gap-2 mt-6 mb-8">
      {/* <p className='absolute h-[2px] mt-[5px] w-[83%] bg-gray-500'></p> */}
      <div className="relative w-full w-12/12 flex justify-center">
        {dataDetail &&
          distributionStatus?.map(
            (status, idx) =>
              idx < 5 && (
                <div
                  key={idx}
                  onClick={() => statusOnClick(dataDetail, idx)}
                  className={
                    `${
                      dataDetail.status === 6 ||
                      dataDetail.status === 5 ||
                      dataDetail.status === 7
                        ? "cursor-default"
                        : "cursor-pointer"
                    }` +
                    " relative w-2/12 flex flex-col justify-start items-center  " +
                    `${
                      idx < 4 &&
                      'after:absolute after:content-[""] after:w-[100%] after:h-[2px] after:bg-gray-400 after:top-[5px] after:left-[50%] after:-z-10'
                    }` +
                    `${
                      idx < dataDetail?.status &&
                      dataDetail?.status !== 6 &&
                      dataDetail?.status !== 5 &&
                      dataDetail?.status !== 7 &&
                      " after:bg-primary"
                    }`
                  }
                >
                  <div
                    className={
                      "rounded-full flex z-10 " +
                      `${
                        (idx <= dataDetail?.status &&
                          dataDetail?.status !== 7 &&
                          dataDetail?.status !== 6 &&
                          dataDetail?.status !== 5) ||
                        (idx === 0 && dataDetail.status === 6) ||
                        (idx === 0 && dataDetail.status === 7) ||
                        (idx === 0 && dataDetail.status === 5)
                          ? "bg-primary border-2 border-primary w-3 h-3 "
                          : "bg-zinc-400 w-3 h-3 border-2 border-white "
                      }` +
                      `${
                        idx < dataDetail?.status &&
                        dataDetail.status !== 6 &&
                        dataDetail.status !== 7 &&
                        dataDetail.status !== 5
                          ? " bg-primary border-2 border-white w-3 h-3 "
                          : " bg-white "
                      }`
                    }
                  ></div>
                  <p
                    className={
                      "relative text-center px-2 " +
                      `${
                        (idx <= dataDetail?.status &&
                          dataDetail.status !== 7 &&
                          dataDetail.status !== 6 &&
                          dataDetail.status !== 5) ||
                        (idx === 0 && dataDetail.status === 7) ||
                        (idx === 0 && dataDetail.status === 6) ||
                        (idx === 0 && dataDetail.status === 5)
                          ? "text-primary"
                          : "text-zinc-400"
                      }`
                    }
                  >
                    {(idx === 0 && dataDetail?.status === 6) ||
                    (idx === 0 && dataDetail?.status === 5) ||
                    (idx === 0 && dataDetail?.status === 7)
                      ? distributionStatus[dataDetail?.status]
                      : status}
                  </p>
                </div>
              )
          )}
      </div>

      {/* Modal Steps Confirm */}
      <Modal
        isOpen={modalStepIsOpen}
        onRequestClose={toggleModalSteps}
        style={customStyles}
        contentLabel="Change Status"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={toggleModalSteps}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
          配布ステイタス設定
        </h2>
        <form onSubmit={statusChangeOnSubmit} className="p-2 flex flex-col">
          {currentStatus === targetStatus ? (
            <p>現在と同じステータスです。</p>
          ) : (
            <div className="w-full w-12/12 flex flex-col justify-between">
              <div className="w-12/12 flex justify-between">
                <p className="w-6/12 text-sm sm:text-lg">現在のステイタス</p>
                <p className="w-6/12 text-sm sm:text-lg">変更後のステイタス</p>
              </div>
              <p className="w-12/12 h-[2px] bg-gray-400 my-4"></p>
              <div className="w-12/12 flex justify-between">
                <p className="w-6/12 text-sm sm:text-lg">{currentStatus}</p>
                <p className="w-6/12 text-sm sm:text-lg">{targetStatus}</p>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-2">
            {currentStatus !== targetStatus && (
              <button
                className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                type="submit"
              >
                確定する
              </button>
            )}

            <button
              onClick={toggleModalSteps}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              {currentStatus !== targetStatus ? "キャンセル" : "閉じる"}
            </button>
          </div>
        </form>
      </Modal>
      {/* End Modal Steps Confirm */}
    </div>
  );
};

export default ProgressStatus;
